import * as sup from "superstruct";

import { createResourceStruct } from "@/modules/api/utils/jsonApiStructs";
import { takenTestQuestionSingleIdentifierStruct } from "@/modules/tutorialTest/resources/takenTestQuestionSingle/takenTestQuestionSingleIdentifierStruct";

import { tutorialStepIdentifierStruct } from "../tutorialStep/tutorialStepIdentifierStruct";

import { tutorialProgressIdentifierStruct } from "./tutorialProgressIdentifierStruct";

export const tutorialProgressResourceStruct = createResourceStruct({
  identifier: tutorialProgressIdentifierStruct,
  attributes: sup.object({
    name: sup.string(),
    pointsNumber: sup.integer(),
    createdAt: sup.string(),
    updatedAt: sup.string(),
  }),
  relationships: sup.object({
    tutorialSteps: sup.object({
      data: sup.array(tutorialStepIdentifierStruct),
    }),
    testQuestions: sup.object({
      data: sup.array(takenTestQuestionSingleIdentifierStruct),
    }),
  }),
  meta: sup.object({
    completedAt: sup.nullable(sup.string()),
    tutorialStepsCompleted: sup.integer(),
    testPassed: sup.boolean(),
  }),
});
